<template>
  <!-- 고객에게 보내는 账单 그림 전용 표 (崔凡 확정 사양 10-13). 견적서 모달과 별개로 그린다 — 보여줄 열만 «그린다»(숨김 아님).
       kakaoSend.js 가 잠깐 화면 밖에 붙여 캡처하고 바로 치운다. 입력값은 customerBill.js 가 거른 값뿐이다. -->
  <div class="cbill" style="width:880px;padding:16px;background:#fff;color:#222;font-family:'Malgun Gothic','Apple SD Gothic Neo',sans-serif;font-size:13px;">
    <!-- 견적서 헤더 — 고객 본인 정보(崔凡 확정 10-13). 견적서 PDF 헤더와 같은 항목·모양 -->
    <div style="font-weight:bold;font-size:14px;margin-bottom:6px;">견적서 (报价单)</div>
    <table style="width:100%;border-collapse:collapse;margin-bottom:12px;font-size:13px;">
      <tr v-for="(row, ri) in headerRows" :key="ri">
        <td v-for="k in row" :key="k" style="width:33%;padding:3px 4px;"><b>{{ label(k) }}:</b> {{ bill.header[k] }}</td>
      </tr>
    </table>
    <table class="cbill-t" style="width:100%;border-collapse:collapse;">
      <thead>
        <tr>
          <th rowspan="2" style="width:30%" :style="th()">상품명</th>
          <th rowspan="2" :style="th()">바코드</th>
          <th rowspan="2" style="width:6%" :style="th()">수량</th>
          <th colspan="3" :style="th('#e8f4fd')">협상전 (CNY)</th>
          <th colspan="3" :style="th('#fff3cd')">협상후 (CNY)</th>
        </tr>
        <tr>
          <th :style="th('#e8f4fd')">단가</th><th :style="th('#e8f4fd')">총배송비</th><th :style="th('#e8f4fd')">합계</th>
          <th :style="th('#fff3cd')">단가</th><th :style="th('#fff3cd')">총배송비</th><th :style="th('#fff3cd')">합계</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(l, i) in bill.lines" :key="i">
          <td :style="td('left')">{{ l.name }}</td>
          <td :style="td('center')">{{ l.barcode }}</td>
          <td :style="td('center')">{{ l.qty }}</td>
          <td :style="td('right')">{{ cny(l.preUnit) }}</td>
          <td v-if="l.span" :rowspan="l.span" :style="td('right', '#f0f8ff')">{{ cny(l.preShip) }}</td>
          <td v-if="l.span" :rowspan="l.span" :style="td('right', '#f0f8ff')">{{ cny(l.preTotal) }}</td>
          <td :style="td('right')">{{ cny(l.postUnit) }}</td>
          <td v-if="l.span" :rowspan="l.span" :style="td('right', '#fff8e1')">{{ cny(l.postShip) }}</td>
          <td v-if="l.span" :rowspan="l.span" :style="td('right', '#fff8e1')">{{ cny(l.postTotal) }}</td>
        </tr>
      </tbody>
    </table>
    <!-- 합계 행 — 综合清关 3칸 / 单独清关 1칸 -->
    <table class="cbill-sum" style="width:100%;border-collapse:collapse;margin-top:-1px;">
      <tbody>
        <tr v-if="bill.integrated">
          <th style="width:40%;border:1px solid #888;background:#eee;padding:6px;text-align:right;">합계</th>
          <th :style="sumTh()">결제금액(KRW)</th>
          <th :style="sumTh()">부가세</th>
          <th :style="sumTh('#dbeafe')">최종금액합계(KRW)</th>
        </tr>
        <tr v-if="bill.integrated">
          <td style="border:1px solid #888;"></td>
          <td :style="sumTd()">{{ krw(bill.totals.결제금액) }}</td>
          <td :style="sumTd()">{{ krw(bill.totals.부가세) }}</td>
          <td :style="sumTd(true)">{{ krw(bill.totals.최종금액) }}</td>
        </tr>
        <tr v-else>
          <th style="width:40%;border:1px solid #888;background:#eee;padding:6px;text-align:right;">합계</th>
          <th :style="sumTh('#dbeafe')">최종결제금액(KRW)</th>
          <td :style="sumTd(true)" style="width:30%">{{ krw(bill.totals.최종금액) }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="bill.hasLogistics" style="margin-top:8px;font-size:12px;color:#555;">※ 물류비는 별도로 입금 요청드립니다.</div>
  </div>
</template>

<script>
export default {
  name: 'CustomerBillTable',
  props: { bill: { type: Object, required: true } },
  computed: {
    headerRows() {
      return [['화주주문번호', '상호', '화주명'], ['통관방식', '적용환율', '요청일'], ['사업자등록번호', '대표자명', '이메일']];
    }
  },
  methods: {
    label(k) { return k; },
    cny(v) { return v == null || v === '' ? '-' : '¥' + Number(v).toLocaleString(); },
    krw(v) { return '₩' + (Number(v) || 0).toLocaleString(); },
    th(bg) { return { border: '1px solid #888', padding: '6px 4px', textAlign: 'center', background: bg || '#eee', fontWeight: 'bold' }; },
    td(al, bg) { return { border: '1px solid #888', padding: '5px 6px', textAlign: al, verticalAlign: 'middle', background: bg || '#fff' }; },
    sumTh(bg) { return { border: '1px solid #888', padding: '6px', textAlign: 'center', background: bg || '#eee' }; },
    sumTd(strong) { return { border: '1px solid #888', padding: '6px', textAlign: 'right', fontWeight: strong ? 'bold' : 'normal', fontSize: strong ? '15px' : '13px' }; }
  }
};
</script>
